import { configureStore } from '@reduxjs/toolkit'
import googleReviews from "./reducer/googleReviews"
import user from './reducer/user'
import station from "./reducer/station"
import reviewsStations from "./reducer/reviewsStations"
import charts from "./reducer/charts"
import review from "./reducer/review"
import manageReviewReducer from './reducer/manageReviewReducer'

export default configureStore({
  reducer: {
    googleReviews: googleReviews,
    user: user,
    station: station,
    reviewsStations: reviewsStations,
    charts: charts,
    review: review,
    manageReviewReducer: manageReviewReducer
  }
})